export const webWorks = [
  {
    id: "w1",
    title: "密室档案",
    type: "web",
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    genres: ["悬疑", "密室", "推理"],
    cover:
      "https://readdy.ai/api/search-image?query=Locked%20room%20mystery%20web%20series%20poster%2C%20a%20dim%20room%20with%20a%20single%20warm%20amber%20lamp%20and%20scattered%20old%20case%20files%2C%20a%20shadowy%20figure%20in%20the%20corner%2C%20crimson%20and%20amber%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-web-w1-cover&orientation=portrait",
    synopsis:
      "一档网络推理节目邀请六位素人挑战者，进入精心设计的\"密室档案\"。每一期都要破解一桩虚构案件，而胜出者将获得线索，拼凑出节目隐藏的终极谜题。随着录制推进，挑战者们渐渐发现，这些案件并非全是虚构——它们都与节目策划人消失的妹妹有关。密室的门一次次打开，真相却越来越近得让人无法呼吸。",
    shortIntro:
      "六位素人挑战者进入推理节目的密室，破解虚构案件的同时，逐渐拼出节目策划人失踪妹妹的真相。",
    cast: ["沈聿", "白晓", "陆一鸣", "苏芮"],
    director: "江砚",
    releaseDate: "2026-06-11",
    totalEpisodes: 24,
    status: "更新至第6集",
    heat: 8760,
    updatedAt: "2026-10-15",
    featured: true,
    highlight: "本格推理与节目真人秀形式结合，节奏紧凑，弹幕解谜互动感极强。",
    episodes: [
      { no: 1, title: "第一扇门", summary: "六位挑战者进入密室，首个案件便是一桩\"不可能的失踪\"。", duration: "38分钟" },
      { no: 2, title: "时间线", summary: "沈聿发现所有人的证词都指向同一分钟的空白。", duration: "37分钟" },
      { no: 3, title: "隐藏规则", summary: "一张被撕掉一角的规则卡，暗示节目还有未公开的玩法。", duration: "39分钟" },
      { no: 4, title: "旧照片", summary: "案件现场的照片里出现了一个不该存在的人影。", duration: "38分钟" },
      { no: 5, title: "背叛", summary: "挑战者内部出现分歧，有人似乎提前知道答案。", duration: "40分钟" },
      { no: 6, title: "档案背后", summary: "第六期真相揭晓，节目隐藏的主线首次浮出水面。", duration: "41分钟" },
    ],
  },
  {
    id: "w2",
    title: "恋恋小食光",
    type: "web",
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    genres: ["甜宠", "美食", "都市"],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20romance%20foodie%20web%20series%20poster%2C%20a%20small%20warm%20night%20market%20food%20stall%20glowing%20with%20amber%20lights%2C%20steaming%20dishes%2C%20two%20figures%20chatting%2C%20warm%20peach%20and%20amber%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-web-w2-cover&orientation=portrait",
    synopsis:
      "美食博主林小满为了拍一期\"深夜食堂\"特辑，误打误撞闯进了主厨江朔经营的小店。一个只会做菜不会说话，一个只会说话不会做菜，两人因一档突然爆火的联名短视频被迫合作。从选食材到熬汤底，从直播翻车到深夜谈心，烟火气里的小心动悄悄发芽。有些喜欢，就像一锅慢炖的汤，越久越香。",
    shortIntro:
      "美食博主林小满与寡言主厨江朔因一档爆火短视频被迫合作，在烟火气里慢慢靠近。",
    cast: ["林小满", "江朔", "阿元"],
    director: "温以宁",
    releaseDate: "2025-09-01",
    totalEpisodes: 20,
    status: "已完结",
    heat: 7020,
    updatedAt: "2026-09-20",
    highlight: "每集一道真实菜品，甜宠与美食双满足，被称\"下饭神器\"。",
    episodes: [
      { no: 1, title: "深夜食堂", summary: "林小满为拍特辑误闯小店，与寡言主厨江朔初次交锋。", duration: "36分钟" },
      { no: 2, title: "联名", summary: "一条意外爆火的短视频，让两人被迫组成搭档。", duration: "35分钟" },
      { no: 3, title: "选食材", summary: "凌晨四点的菜市场，两人第一次聊起各自的故事。", duration: "37分钟" },
      { no: 4, title: "直播翻车", summary: "直播现场突发状况，江朔一句话救了全场。", duration: "36分钟" },
      { no: 5, title: "慢炖", summary: "一锅熬了三天的汤底，藏着江朔不愿提起的过去。", duration: "38分钟" },
      { no: 6, title: "一起吃饭", summary: "关店之后，两人第一次为彼此做了一顿饭。", duration: "37分钟" },
    ],
  },
  {
    id: "w3",
    title: "我在古代当网红",
    type: "web",
    region: "中国大陆",
    year: 2026,
    rating: 7.7,
    genres: ["穿越", "喜剧", "古装"],
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20time%20travel%20comedy%20web%20series%20poster%2C%20a%20modern%20girl%20in%20colorful%20ancient%20robe%20holding%20a%20phone%20in%20a%20bustling%20ancient%20market%2C%20warm%20amber%20and%20coral%20color%20grading%2C%20lively%20composition%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-web-w3-cover&orientation=portrait",
    synopsis:
      "短视频运营达人夏呦呦一觉醒来，发现自己穿越到了没有手机、没有网络的古代小镇。为了活下去，她重操旧业，用说书、戏法和\"话题营销\"在集市里闯出名堂，成了名副其实的\"古代网红\"。只是人怕出名猪怕壮，她的名声很快传到了县衙与商行耳中。想在这个时代站稳脚跟，光有流量可不够。",
    shortIntro:
      "短视频达人夏呦呦穿越到古代小镇，用说书与\"话题营销\"闯出名堂，成了古代网红。",
    cast: ["夏呦呦", "顾掌柜", "小翠"],
    director: "花间",
    releaseDate: "2026-07-03",
    totalEpisodes: 24,
    status: "更新至第6集",
    heat: 7580,
    updatedAt: "2026-10-07",
    highlight: "脑洞大开的穿越喜剧，古今碰撞梗多而不尬，解压首选。",
    episodes: [
      { no: 1, title: "一觉醒来", summary: "夏呦呦醒来发现自己身处古代，第一件事是找充电口。", duration: "34分钟" },
      { no: 2, title: "说书摊", summary: "为赚第一桶金，她在集市支起了\"爆款说书摊\"。", duration: "33分钟" },
      { no: 3, title: "话题营销", summary: "一个精心设计的\"悬念\"，让全城都在打听她的名字。", duration: "35分钟" },
      { no: 4, title: "顾掌柜", summary: "绸缎庄顾掌柜找上门，想请她做一桩特别的生意。", duration: "34分钟" },
      { no: 5, title: "人红是非", summary: "名声带来追捧，也带来县衙的注意。", duration: "36分钟" },
      { no: 6, title: "古代带货", summary: "一场别开生面的\"带货大会\"，让她的生意再上台阶。", duration: "35分钟" },
    ],
  },
  {
    id: "w4",
    title: "深夜书房",
    type: "web",
    region: "日本",
    year: 2025,
    rating: 8.6,
    genres: ["治愈", "单元剧", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20bookstore%20web%20series%20poster%2C%20a%20small%20warm%20bookshop%20interior%20at%20night%20with%20amber%20lamps%20and%20tall%20wooden%20shelves%2C%20a%20lone%20reader%2C%20warm%20amber%20and%20soft%20brown%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-web-w4-cover&orientation=portrait",
    synopsis:
      "在城市一隅，有一间只在午夜后营业的旧书房。店主是一位话不多的老人，他从不主动推销，只在客人离店时递上一本\"恰好合适\"的书。每一集，一位带着烦恼的客人走进书房，带走一个不一样的故事。淡淡的灯光下，书与人彼此治愈，也悄悄回答了那些白天里说不出口的问题。",
    shortIntro:
      "一间只在午夜后营业的旧书房，店主总递上\"恰好合适\"的书，每集治愈一位带着烦恼的客人。",
    cast: ["店主", "小林香织", "山口"],
    director: "佐藤悠介",
    releaseDate: "2025-12-05",
    totalEpisodes: 18,
    status: "已完结",
    heat: 6980,
    updatedAt: "2026-09-24",
    featured: true,
    highlight: "安静治愈的单元剧，每集结尾的金句都会被观众截图收藏。",
    episodes: [
      { no: 1, title: "第一位客人", summary: "深夜，一位失眠的上班族推开了书房的门。", duration: "32分钟" },
      { no: 2, title: "未寄出的信", summary: "客人想找一本关于\"告别\"的书，店主却递上了别的。", duration: "31分钟" },
      { no: 3, title: "旧地图", summary: "一位想辞职的年轻人，在一本旅行书里找到了答案。", duration: "33分钟" },
      { no: 4, title: "同名的人", summary: "客人发现书里主角与自己同名，仿佛被写中了人生。", duration: "32分钟" },
      { no: 5, title: "雨夜", summary: "大雨困住了一位客人，店主第一次讲起自己的故事。", duration: "34分钟" },
      { no: 6, title: "灯还亮着", summary: "书房要搬走了，客人们却在这个夜晚不约而同地回来。", duration: "33分钟" },
    ],
  },
  {
    id: "w5",
    title: "悬案笔记",
    type: "web",
    region: "韩国",
    year: 2026,
    rating: 8.3,
    genres: ["悬疑", "犯罪", "心理"],
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20crime%20mystery%20web%20series%20poster%2C%20a%20detective%20reading%20a%20worn%20notebook%20under%20a%20single%20amber%20desk%20lamp%20in%20a%20dark%20office%2C%20crimson%20and%20amber%20color%20grading%2C%20moody%20shadows%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-web-w5-cover&orientation=portrait",
    synopsis:
      "犯罪侧写师韩瑞妍接手了三起被搁置多年的悬案，唯一的共同点，是现场都留下一页手写笔记。笔记的字迹与她失踪的导师如出一辙。为查明真相，她不得不与曾经的老搭档、如今已离开警队的姜道允重新合作。随着一页页笔记被解开，她发现凶手似乎一直在观察着她，而这个故事从一开始就写好了结局。",
    shortIntro:
      "犯罪侧写师韩瑞妍重查三起悬案，现场留下的手写笔记与她失踪的导师如出一辙。",
    cast: ["韩瑞妍", "姜道允", "朴组长"],
    director: "金度允",
    releaseDate: "2026-08-14",
    totalEpisodes: 20,
    status: "更新至第6集",
    heat: 8120,
    updatedAt: "2026-10-13",
    highlight: "心理侧写与悬案推理并重，气氛压迫感极强，反转设计精巧。",
    episodes: [
      { no: 1, title: "第一页", summary: "韩瑞妍翻开一桩旧案卷宗，发现现场遗留的手写笔记。", duration: "40分钟" },
      { no: 2, title: "字迹", summary: "笔记的字迹，指向一个她最不愿意相信的人。", duration: "39分钟" },
      { no: 3, title: "旧搭档", summary: "为了重查旧案，她不得不去找已经离队的老搭档。", duration: "41分钟" },
      { no: 4, title: "侧写", summary: "一份凶手侧写报告，让所有人都沉默了。", duration: "40分钟" },
      { no: 5, title: "被观察者", summary: "她意识到，凶手或许一直在观察自己的每一步。", duration: "42分钟" },
      { no: 6, title: "续页", summary: "第二页笔记出现，上面写着只有她才知道的事。", duration: "41分钟" },
    ],
  },
  {
    id: "w6",
    title: "平行恋人",
    type: "web",
    region: "中国大陆",
    year: 2025,
    rating: 7.9,
    genres: ["奇幻", "爱情", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20web%20series%20poster%2C%20two%20versions%20of%20the%20same%20young%20couple%20standing%20back%20to%20back%20separated%20by%20a%20glowing%20seam%20of%20light%2C%20warm%20amber%20and%20coral%20color%20grading%2C%20surreal%20atmosphere%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-web-w6-cover&orientation=portrait",
    synopsis:
      "设计师温棠在一场暴雨后，发现手机相册里多出了许多从未拍过的照片，照片里的人是自己，却又不是自己。一次偶然，她接通了一个陌生号码，对面自称是\"另一个世界\"的程屿。两个平行世界因一次意外产生了微弱的连接，而这连接正在迅速消失。在有限的通话里，他们试着弄明白：究竟哪一个世界，才是他们真正想要留下的地方。",
    shortIntro:
      "设计师温棠接通了一通来自平行世界的电话，对面是\"另一个自己\"世界的程屿，连接正在消失。",
    cast: ["温棠", "程屿", "阿城"],
    director: "顾一川",
    releaseDate: "2025-11-20",
    totalEpisodes: 20,
    status: "已完结",
    heat: 7240,
    updatedAt: "2026-09-27",
    highlight: "平行世界的浪漫设定加上严密逻辑，结局的抉择引发大量讨论。",
    episodes: [
      { no: 1, title: "多出的照片", summary: "温棠发现相册里多出许多自己从未拍过的照片。", duration: "36分钟" },
      { no: 2, title: "陌生来电", summary: "一个陌生号码接通，对面自称来自另一个世界。", duration: "35分钟" },
      { no: 3, title: "两个世界", summary: "他们开始记录两个世界之间细微的差异。", duration: "37分钟" },
      { no: 4, title: "信号减弱", summary: "通话时间越来越短，连接似乎正在消失。", duration: "36分钟" },
      { no: 5, title: "见一面", summary: "为了见一面，他们尝试了一个冒险的办法。", duration: "38分钟" },
      { no: 6, title: "留下", summary: "连接即将断裂，他们必须决定各自留在哪里。", duration: "37分钟" },
    ],
  },
];